import Store from '@/store';
import SLS_pedidosVendas from '@/api/Operacoes/sls_pedidosVendas';
import SLSItemsClient from '@/api/sls-items.client';
import Notifier from '@/libs/Notifier';
import { ErrorMessage } from '@/libs/Error';

export default class SLS_pedidosVendasService {
  constructor() {
    this.client = new SLS_pedidosVendas();
    this.clientItems = new SLSItemsClient();
    this.store = Store;
    this.notify = new Notifier();
    this.error = new ErrorMessage();
  }

  async itensMarcaPedido(precoId) {
    try {
      return await this.client.itensMarcaPedido(precoId);
    } catch (error) {
      this.notify.error(error);
    }
  }

  async itensCategoriaPedido(cod_marca) {
    try {
      return await this.client.itensCategoriaPedido(cod_marca);
    } catch (error) {
      this.notify.error(error);
    }
  }

  async itensReferenciaPedido(codmarca, codcategoria) {
    try {
      return await this.client.itensReferenciaPedido(codmarca, codcategoria);
    } catch (error) {
      this.notify.error(error);
    }
  }

  async itensEmbalagemPedido(fml_comercialId, precoId) {
    try {
      return await this.client.itensEmbalagemPedido(fml_comercialId, precoId);
    } catch (error) {
      this.notify.error(error);
    }
  }

  async itensImagemPedido(codmarca, familia_comercial) {
    try {
      return await this.client.itensImagemPedido(codmarca, familia_comercial);
    } catch (error) {
      this.notify.error(error);
    }
  }

  async ItemPedido(cod_marca, cod_categ, familia_comercial) {
    try {
      return await this.client.ItemPedido(cod_marca, cod_categ, familia_comercial);
    } catch (error) {
      this.notify.error(error);
    }
  }

  async precoItensPedido(tabelaPrecoId, item) {
    try {
      return await this.client.precoItemPedido(tabelaPrecoId, item);
    } catch (error) {
      this.notify.error(error);
    }
  }

  async getDetalhesItems(dataFind) {
    console.log('getDetalhesItems-service:', dataFind);
    try {
      return await this.clientItems.getInfoItemByCodCategEndCodMarca(dataFind);
    } catch (error) {
      console.log('error--detalhes', error);
      throw this.error.message(error, 'Erro ao buscar os detalhes do item');
    }
  }

  async detalhesPedidoStored(familiaComercialId, precoId, codMarca, codCateg) {
    try {
      const response = await this.clientItems.detalhesPedidoStored(
        familiaComercialId,
        precoId,
        codMarca,
        codCateg,
      );

      if (!response.success) {
        this.notify.error(response.message || 'Erro ao buscar detalhes do item');
        return null;
      }

      return response.data;
    } catch (error) {
      console.log('error--detalhes', error);
      throw this.error.message(error, 'Erro ao buscar os detalhes do item');
    }
  }

  async buscarReferenciaPorCodigo(codReferencia, tabelaPrecoId) {
    try {
      return await this.client.buscarReferenciaPorCodigo(codReferencia, tabelaPrecoId);
    } catch (error) {
      this.notify.error(error);
    }
  }

  async getRascunhosPedidosVendas(params) {
    try {
      return await this.client.getRascunhosPedidosVendas(params);
    } catch (error) {
      this.notify.error(error);
    }
  }
}
